'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = LayoutComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LayoutComponent(props) {
    var className = props.className,
        style = props.style,
        width = props.width,
        height = props.height,
        direction = props.direction,
        justifyContent = props.justifyContent,
        alignItems = props.alignItems,
        others = (0, _objectWithoutProperties3.default)(props, ['className', 'style', 'width', 'height', 'direction', 'justifyContent', 'alignItems']);


    className = (0, _classnames2.default)((0, _defineProperty3.default)({
        'mk-layout': true
    }, className, !!className));

    style = style || {};

    if (width) {
        style.flex = '0 0 ' + width + 'px';
        style.width = width + 'px';
    }

    if (height) {
        style.flex = '0 0 ' + height + 'px';
        style.height = height + 'px';
    }

    if (direction) {
        style.flexDirection = direction;
    }

    style.justifyContent = justifyContent;

    if (alignItems) {
        style.alignItems = alignItems;
    }

    return _react2.default.createElement('div', (0, _extends3.default)({}, others, { className: className, style: style }));
}
module.exports = exports['default'];